var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatListBulleti = function SvgChatListBulleti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M6.5 14.687A.68.68 0 0 1 7.191 14a.687.687 0 1 1 0 1.374.68.68 0 0 1-.691-.687m3.068.413a.411.411 0 1 1 0-.823h7.516a.411.411 0 1 1 0 .823zM6.5 11.936a.68.68 0 0 1 .691-.686.688.688 0 0 1 0 1.375.68.68 0 0 1-.691-.689m3.065.413a.413.413 0 1 1 0-.825h7.516a.413.413 0 1 1 0 .825zM6.5 9.187a.68.68 0 0 1 .689-.687.68.68 0 0 1 .686.687.68.68 0 0 1-.686.688.68.68 0 0 1-.689-.688m3.07.413a.41.41 0 0 1-.417-.413.405.405 0 0 1 .417-.411h7.519a.4.4 0 0 1 .411.411.41.41 0 0 1-.411.416z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatListBulleti);
export default ForwardRef;